import {
  FRIENDS_ICON,
  HOME_ICON,
  MY_BOOKINGS_ICON,
  MY_CORPORATE_BENEFITS_ICON,
  MY_FAVORITES_ICON,
  MY_PASSES_ICON,
  MY_PAYMENT_METHODS_ICON,
  MY_PERSONAL_INFORMATION_ICON,
  MY_PROFILE_ICON,
  MY_VIDEOS_ICON,
  SIGNOUT_ICON,
} from '../../../App.icons'

import { UserItem } from './UserMenu.types'

export enum AuthRoutes {
  LOGIN = '/auth/',
  REGISTER = '/auth/register',
}

enum UserProfileRoutes {
  HOME = '/',
  RECOMMENDATIONS = '/recommendations',
  MY_BOOKINGS = '/u',
  MY_VIDEOS = '/u/videos',
  MY_PASSES = '/u/credits',
  MY_FAVORITES = '/u/facilities',
  MY_INFO = '/u/edit',
  MY_PAYMENT_METHODS = '/u/payment-methods',
  MY_CORPORATE_BENEFITS = '/u/corporate-benefits',
  SIGNOUT = '/u/logout',
}

enum From {
  USER_MENU = 'user-menu',
}

export const LoggedInUserMenuItems = ({
  userHandle,
  hasCorporateBenefits,
}: {
  userHandle: string
  hasCorporateBenefits: boolean
}): Array<UserItem> => [
  {
    icon: HOME_ICON,
    translationKey: 'user-menu-home',
    to: '/',
  },
  {
    icon: MY_CORPORATE_BENEFITS_ICON,
    translationKey: 'user-menu-my-corporate-benefits',
    to: '/u/corporate-benefits',
    isHidden: !hasCorporateBenefits,
  },
  {
    icon: MY_PROFILE_ICON,
    translationKey: 'user-menu-my-profile',
    to: `/user/${userHandle}?from=${From.USER_MENU}`,
    isNew: true,
  },
  {
    icon: FRIENDS_ICON,
    translationKey: 'user-menu-my-friends',
    to: `/user/${userHandle}/friends?from=${From.USER_MENU}`,
    isNew: true,
    // notification: <NumberOfPendingFriendRequests />,
  },
  {
    icon: MY_BOOKINGS_ICON,
    translationKey: 'user-menu-my-bookings',
    to: UserProfileRoutes.MY_BOOKINGS,
  },
  {
    icon: MY_VIDEOS_ICON,
    translationKey: 'user-menu-my-videos',
    to: UserProfileRoutes.MY_VIDEOS,
  },
  {
    icon: MY_PASSES_ICON,
    translationKey: 'user-menu-my-passes-and-memberships',
    to: UserProfileRoutes.MY_PASSES,
  },
  {
    icon: MY_FAVORITES_ICON,
    translationKey: 'user-menu-my-favorites',
    to: UserProfileRoutes.MY_FAVORITES,
  },
  {
    icon: MY_PERSONAL_INFORMATION_ICON,
    translationKey: 'user-menu-my-personal-information',
    to: UserProfileRoutes.MY_INFO,
  },
  {
    icon: MY_PAYMENT_METHODS_ICON,
    translationKey: 'user-menu-my-payment-methods',
    to: UserProfileRoutes.MY_PAYMENT_METHODS,
  },
  {
    icon: SIGNOUT_ICON,
    translationKey: 'user-menu-signout',
    to: UserProfileRoutes.SIGNOUT,
  },
]
